import { styled } from "styled-components";
const InlineWrapper = styled("div")(
  {
    display: "flex",
    "&:focus": {
      boxShadow: "none"
    }
  },
  ({ $align, $alignY }) => ({
    bottom: {
      alignItems: "flex-end"
    },
    center: {
      alignItems: "center"
    },
    end: {
      alignItems: "flex-end"
    },
    start: {
      alignItems: "flex-start"
    },
    top: {
      alignItems: "flex-start"
    }
  })[$align || $alignY],
  ({ $alignX, $justify }) => ({
    center: {
      justifyContent: "center"
    },
    end: {
      justifyContent: "flex-end"
    },
    left: {
      justifyContent: "flex-start"
    },
    right: {
      justifyContent: "flex-end"
    },
    "space-around": {
      justifyContent: "space-around"
    },
    "space-between": {
      justifyContent: "space-between"
    },
    "space-evenly": {
      justifyContent: "space-evenly"
    },
    start: {
      justifyContent: "flex-start"
    }
  })[$justify || $alignX],
  ({ $noWrap }) => $noWrap ? {
    overflow: "hidden",
    whiteSpace: "nowrap"
  } : void 0
);
const InlineItem = styled("div")(
  {
    flex: "1 1 0",
    maxWidth: "max-content",
    overflow: "inherit",
    textOverflow: "ellipsis"
  },
  ({ $space, $spacing }) => {
    const marginValue = {
      xsmall: 2,
      small: 4,
      medium: 8,
      large: 12,
      xlarge: 16
    }[$space];
    const oldMarginValue = {
      small: 2,
      medium: 4,
      large: 8,
      xlarge: 16
    }[$spacing];
    return {
      "&:not(:first-child)": {
        marginLeft: marginValue || oldMarginValue
      },
      "&:not(:last-child)": {
        marginRight: marginValue || oldMarginValue
      }
    };
  }
);
export {
  InlineItem,
  InlineWrapper
};
